<ng-container *ngIf="isLoading$ | async"></ng-container>
<ngx-spinner></ngx-spinner>
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2> {{'MENU.CAREERS' | translate}} </h2>
        <ul>
          <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{'MENU.CAREERS' | translate}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="appointment-area-two" style="margin-top: 500px;margin-bottom: -115px;"></div>
<!-- <div class="appointment-area-two" style="margin-top: 20px;margin-bottom: -115px;">
  <div class="container">
    
    <div class="row align-items-center appointment-wrap-two">
      <div class="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
        <div class="appointment-item appointment-item-two ">
          <div class="text-center" style="margin: -20px 0px 10px 0px;">
            <h2 style="font-weight: bold;font-size: 34px;">{{ language == 'en'? 'Your Medicines':'Your Medicines'}}</h2>
        </div>
        <div class="table-responsive angular-bootstrap-table">
          <table class="table table-bordered table-responsive" >
            <thead style="color: #205d89">

              <th>
                Medicine Name
              </th>
              <th>
                Dosage
              </th>
              <th>
                Description
              </th>
              <th>
                Frequency
              </th>
              <th>
                Duration
              </th>
              <th>ACTIONS</th>
            </thead>
            <tbody>
              <tr *ngFor="let medicine of medicines">

                <td style="width: 700px;">{{ medicine.itemName }}</td>

                <td >{{ medicine.dosage }}</td>
                <td>{{ medicine.routeDesc }}</td>

                <td style="width: 400px;">{{ medicine.frequency }}</td>
                <td >{{ medicine.duration }}</td>
                <td>
                  <button type="button" class="btn btn-primary" (click)="MedicineTaked(medicine)">Taken</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
         
        </div>
      </div>
    </div>



  </div>
</div> -->